import { configureStore } from '@reduxjs/toolkit';
import reducers from './redux/reducers';

const store = configureStore({
	reducer: reducers, // Replace this with a combined reducer if needed
	devTools: process.env.NODE_ENV !== 'production' // Enables Redux DevTools only in non-production environments
});

export default store;
